import { AssessmentSurveyType } from "@/shared/constants/assessmentSurveys";

export const getIsSurveysCompleted = (
  completedDimTypes: AssessmentSurveyType[],
  config?: AssessmentSurveyType[]
) => {
  if (!config || config.length === 0) {
    return true;
  }

  return config.every((surveyType) => completedDimTypes?.includes(surveyType));
};
